export default __webpack_public_path__ + "static/media/Rectangle 47.631aa995.svg";